import React from 'react'

import { FormGroup, Label } from '~/components/unform'
import InputCpfCnpj from '~/components/unform/Input/InputCpfCnpj'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

export const IdentificationNumberBR = () => {
  const { t } = useAPPTranslation()

  return (
    <FormGroup className="span2">
      <Label>{t('rm:payment.billing.cnpj.label')}</Label>
      <InputCpfCnpj
        name="identificationNumber"
        placeholder={t('rm:payment.billing.cnpj.placeholder')}
        required
        mode="cnpj"
      />
    </FormGroup>
  )
}
